// Panel-dock strings (Spanish) — English in ./gameLayoutEn.ts.

export const gameLayoutEs = {
  // Panel docks (per-player HUD layout)
  'layout.collapsePanel': 'Contraer panel',
  'layout.expandPanel': 'Expandir panel',
  'layout.movePanel': 'Arrastra para mover este panel a otro lado',
  'layout.resizePanel': 'Redimensionar panel',
  'settings.tab.interface': 'Interfaz',
  'settings.layout.description':
    'Los paneles se pueden arrastrar al muelle izquierdo, derecho o inferior, redimensionar por su borde interior y contraer en un botón del muelle. Tu disposición se guarda por jugador.',
  'settings.layout.reset': 'Restaurar diseño de paneles',
} as const;
